import { useTranslate } from "../../../../hooks/useTranslate";

import { FormTypography } from "@/forms-design-system/FormTypography";

export type ThemedBidStatusProps = {
  status: "yourBid" | "newTopBid" | "currentBid" | "startingBid";
};

export const ThemedBidStatus = ({ status }: ThemedBidStatusProps) => {
  const { t } = useTranslate();

  const vibe = status === "startingBid" ? "supershy" : "brand";

  return (
    <FormTypography variant="body2" vibe={vibe}>
      {t(`ticketing`, `auctionV2.input.${status}`)}
    </FormTypography>
  );
};
